import posthog from 'posthog-js';
import { browser } from '$app/environment';
import * as Sentry from '@sentry/sveltekit';

export const ssr = false;

export const load = async () => {
    if (browser) {
        posthog.init(
            import.meta.env.VITE_POSTHOG_KEY,
            {
                api_host: 'https://us.i.posthog.com',
                person_profiles: 'always',
                capture_pageview: false,
                capture_pageleave: false,
                capture_exceptions: false,
            }
        );

        Sentry.setUser({ id: posthog.get_distinct_id() });
    }
};
